module.exports = __webpack_public_path__ + "static/media/carousel.92d1119d.svg";